module.exports = __webpack_public_path__ + "static/media/thumbnail.3a93312b.jpg";